import * as types from '../actions/actionTypes';
import initialState from './initialState';
import _ from 'lodash';

export default function userReducer(state = initialState.users, action) {
    switch (action.type) {
        case types.GET_ALL_USERS_SUCCESS:
            return action.users;
        case types.STORE_USER_SUCCESS:
            return [
                ...state,
                action.user
            ];
        case types.UPDATE_USER_SUCCESS:
            return updateUser(state, action.user);
        default:
            return state;
    }
}

function updateUser(state, user) {
    const index = _.findIndex(state, {id: user.id});
    let newState = _.clone(state);
    newState = _.reject(newState, {id: user.id});
    newState.splice(index, 0, user);
    return newState;
}


/** WEBPACK FOOTER **
 ** ./src/reducers/userReducer.js
 **/